<section
  class="tw-mx-4 tw-rounded-[15px] tw-animated-gradient-border tw-shadow-z4 tw-flex tw-items-center tw-gap-3 tw-p-2 tw-cursor-pointer"
  [class]="thumbnailUrl() ? 'tw-pl-2' : 'tw-pl-4'"
  style="--border-color-from: var(--cureskin-teal-500); --border-color-to: var(--cureskin-teal-100); --border-bg: var(--cureskin-teal-50)"
  (click)="handleClick()"
>
  @if (thumbnailUrl()) {
    <div class="tw-shrink-0 tw-w-14 tw-h-14 tw-rounded-lg tw-bg-gray-100 tw-overflow-hidden">
      <img
        class="tw-w-full tw-h-full tw-object-cover"
        [src]="thumbnailUrl()"
        alt=""
      />
    </div>
  }
  <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
    @if (consultationClass === ApiClientConstant.Regimen.Class.HAIR) {
      <span class="tw-font-body tw-font-bold tw-text-400 tw-text-gray-800 tw-leading-[21px]" i18n="@@checkYourHairReport">Check your hair report</span>
    } @else {
      <span class="tw-font-body tw-font-bold tw-text-400 tw-text-gray-800 tw-leading-[21px]" i18n="@@checkYourSkinReport">Check your skin report</span>
    }
    <span class="tw-font-body tw-font-medium tw-text-200 tw-text-gray-500 tw-leading-[18px]" i18n="@@basedOnYourDetails">Based on your details</span>
  </div>
  <cs-icon class="tw-h-4 tw-w-4 tw-shrink-0 tw-mr-1" [iconName]="'chevron_right_teal_rounded'"></cs-icon>
</section>
